<template>
  <yd-layout class="backgroup-image bk-tm" :style="style">
<!--    <yd-navbar slot="navbar" title="">-->
<!--      <router-link to="" @click.native="HistoryBack()" slot="left">-->
<!--        <yd-navbar-back-icon>返回</yd-navbar-back-icon>-->
<!--      </router-link>-->
<!--    </yd-navbar>-->

    <router-view />

    <yd-tabbar slot="tabbar">
      <yd-tabbar-item
        v-for="(item, key) in footer"
        :key="key"
        :title="item.title"
        :link="item.link"
        :active="item.active"
        v-model="footer"
        @click.native="activeCheck(item.ident)"
      >
        <yd-icon :name="item.icon" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
    </yd-tabbar>
  </yd-layout>
</template>
<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'

export default {
  data () {
    return {
      hotelList: [],
      fairDetail: [],
      backgroupData: [],
      params: this.$route.params,
      template: '',
      cms_url: '',
      footer: [
        {
          icon: 'home',
          title: '首页',
          ident: 'home',
          link: '/' + this.$route.params.id + '?code=' + this.$route.query.code,
          active: true
        },
        {
          icon: 'compose',
          title: '报名',
          ident: 'fair-buy',
          link: '/' + this.$route.params.id + '/fair-buy',
          active: false
        },
        {
          icon: 'ucenter-outline',
          title: '个人中心',
          ident: 'single-my',
          link: '/' + this.$route.params.id + '/single-my',
          active: false
        }
      ],
      style: {}
    }
  },
  created () {
    if (this.$route.params.id === undefined) {
      this.$router.push({path: '/fair-list'})
      return false
    }
    if (this.$route.fullPath === this.footer[0].link || this.$route.fullPath === '/' + this.$route.params.id) {
      if (this.template === '3') {
        window.location.href = this.cms_url
        return false
      }
    }
  },
  methods: {
    activeCheck (ident) {
      this.footer.forEach(item => {
        if (item.link === this.$route.fullPath || ('/' + this.$route.params.id === this.$route.fullPath && item.link === '/' + this.$route.params.id + '?code=' + this.$route.query.code)) {
          if (item.ident === 'home') {
            if (this.template === '3') {
              window.location.href = this.cms_url
              return false
            }
            this.style = {backgroundImage: 'url(' + this.fairDetail.mimg + ')', color: 'white', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'top center'}
          }
          item.active = true
        } else {
          item.active = false
        }
      })
    },
    getFairDetail () {
      if (this.$route.query.code && this.$route.query.code !== 'undefined') {
        localStorage.setItem('code', this.$route.query.code)
      }
      let data = {id: this.params.id, limit: 20}
      axios
        .post('/fair/fair-detail', data)
        .then(this.getFairDetailSucc)
    },
    getFairDetailSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.fairDetail = res.data.fair
        localStorage.ing = this.fairDetail.iskaishi

        if (this.fairDetail.isjdkaishi === 1) {
          localStorage.jding = 1
        } else {
          localStorage.jding = 0
        }
        this.template = this.fairDetail.template
        this.cms_url = this.fairDetail.cms_url
        localStorage.setItem('fair_name', this.fairDetail.fair_name)
        localStorage.setItem('fair_id', this.fairDetail.id)
        document.title = this.fairDetail.fair_name
        this.activeCheck()
        this.xuzhi = res.data.system
        localStorage.hotel_xuzhi = this.xuzhi.hotel_xuzhi
        localStorage.ticket_xuzhi = this.xuzhi.ticket_xuzhi
        this.weixinshare()
      } else {
        // this.$dialog.alert({mes: '会议不存在'})
      }
    },
    HistoryBack () {
      window.history.back()
    },
    weixinshare () {
      let data = {fairid: this.params.id, url: window.location.href}
      axios
        .post('/fair/weixinfx', data)
        .then(res => {
          let datafx = res.data
          wx.config({
            debug: false,
            appId: datafx.data.appId,
            timestamp: datafx.data.timestamp,
            nonceStr: datafx.data.nonceStr,
            signature: datafx.data.signature,
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              'checkJsApi',
              'openLocation',
              'getLocation',
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          })
          let that = this
          wx.ready(function () {
            wx.onMenuShareAppMessage({
              title: that.fairDetail.sharetitle,
              desc: that.fairDetail.sharedescription,
              link: window.location.href,
              imgUrl: that.fairDetail.shareimg,
              trigger: function (res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                // alert('用户点击发送给朋友');
              },
              success: function (res) {
                // alert('已分享');
              },
              cancel: function (res) {
                // alert('已取消');
              },
              fail: function (res) {
                // alert(JSON.stringify(res));
              }
            })

            wx.onMenuShareTimeline({
              title: that.fairDetail.sharetitle,
              desc: that.fairDetail.sharedescription,
              link: window.location.href,
              imgUrl: that.fairDetail.shareimg,
              trigger: function (res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                // alert('用户点击分享到朋友圈');
              },
              success: function (res) {
                // alert('已分享');
              },
              cancel: function (res) {
                // alert('已取消');
              },
              fail: function (res) {
                // alert(JSON.stringify(res));
              }
            })
          })
        })
    }
  },
  mounted () {
    this.getFairDetail()
    this.activeCheck()
  },
  watch: {
    $route (to, from) {
      this.activeCheck()
      if (to.fullPath !== this.footer[0].link && to.fullPath !== '/' + this.$route.params.id) {
        this.style = {}
      }
    }
  }
}
</script>

<style lang="stylus">
  .bk-tm .yd-grids-3
    background none
    padding 0 .1rem

  .bk-tm .yd-grids-txt
    color #fff
    
  .bk-tm .yd-grids-3 .yd-grids-item
    width calc((100% - .8rem) / 3)
    padding .3rem 0
    margin .1rem .1rem
    background-color rgba(15,15,135,0.4)
    // background-color rgba(5,5,40,1)
  .bottom
    bottom .2rem !important
</style>



// WEBPACK FOOTER //
// src/views/template1/index.vue